import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { OrganisationService, OrgAppAccess } from 'src/app/organisation.service';

@Component({
  selector: 'app-org',
  templateUrl: './org.component.html',
  styleUrls: ['./org.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, RouterLink]
})
export class OrgComponent implements OnInit {
  id: string;
  responseJson: string;
  hasApiError = false;
  apiError: string;
  org: any;
  orgUsers: any;
  addCreditAmount: number;
  appAccess: OrgAppAccess;
  appAccessSaved = false;

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig,
    private route: ActivatedRoute,
    private orgService: OrganisationService,
  ) { }

  ngOnInit(): void {
    this.appAccess = this.orgService.getDefaultAppAccess();

    this.id = this.route.snapshot.paramMap.get('id');
    this.api.getOrganisationsId$(this.id).subscribe({
      next: (res) => {
        this.hasApiError = false;
        this.org = res;
        this.appAccess = this.orgService.getOrgAppAccess(res);
      },
      error: () => this.hasApiError = true,
    });

    this.api.getOrganisationsIdUsers$(this.id).subscribe({
      next: (res) => {
        this.hasApiError = false;
        this.orgUsers = res;
      },
      error: () => this.hasApiError = true,
    });
  }

  saveAppAccess() {
    this.orgService.setOrgAppAccess(this.id, this.appAccess);

    if (this.org && this.org.id) {
      this.orgService.setOrg(this.org);
    }

    this.appAccessSaved = true;
    window.setTimeout(() => {
      this.appAccessSaved = false;
    }, 2500);
  }

  toggleAddCredit() {
    this.org.editing = !this.org.editing;
  }

  addCredit() {

    this.hasApiError = false;

    if (!this.addCreditAmount) {
      this.hasApiError = true;
      this.apiError = 'Please enter a positive integer value';
      return;
    }

    this.org.cpu_seconds_remaining += Number(this.addCreditAmount);

    this.api.putOrganisationsId$(this.id, this.org).subscribe({
      next: (res) => {
        this.org = res;
        this.addCreditAmount = null;
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }
}
